import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Button,
  Input,
} from "reactstrap";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE, ANSWER_TYPES } from "components/constant";
import { useNavigate } from "react-router-dom";
import AdminHeader from "components/Headers/AdminHeader";
import Select from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";

const questionData = [
  {
    id: 1,
    question: "What is Ohm's Law?",
    options: ["V = IR", "P = VI", "I = V/R", "R = VI"],
    type: "MCQ",
    marks: 2,
  },
  {
    id: 2,
    question: "Select prime numbers",
    options: ["2", "3", "4", "6"],
    type: "MULTI",
    marks: 3,
  },
];
const Questions = () => {
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [searchState, setSearchState] = useState({
    query: "",
    type: null,
    filterParams: [],
  });

  const handleSelectAll = () => {
    if (selectedQuestions.length === questionData.length) {
      setSelectedQuestions([]); // unselect all
    } else {
      setSelectedQuestions(questionData.map((q) => q.id)); // select all
    }
  };

  const handleSelect = (id) => {
    setSelectedQuestions((prev) =>
      prev.includes(id) ? prev.filter((q) => q !== id) : [...prev, id],
    );
  };

  const columns = [
    {
      Header: (
        <Input
          type="checkbox"
          checked={
            selectedQuestions.length === questionData.length &&
            questionData.length > 0
          }
          onChange={handleSelectAll}
        />
      ),
      accessor: "checkbox",
      Cell: ({ row }) => (
        <Input
          type="checkbox"
          checked={selectedQuestions.includes(row.original.id)}
          onChange={() => handleSelect(row.original.id)}
        />
      ),
    },
    {
      Header: "Question",
      accessor: "question",
    },
    {
      Header: "Options",
      accessor: "options",
      Cell: ({ value }) => (
        <div>
          {value.map((opt, i) => (
            <div key={i}>• {opt}</div>
          ))}
        </div>
      ),
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ value }) => {
        switch (value) {
          case "MCQ":
            return "Single Choice";
          case "MULTI":
            return "Multiple Choice";
          case "TF":
            return "True / False";
          default:
            return value;
        }
      },
    },
    {
      Header: "Marks",
      accessor: "marks",
    },
  ];

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">Select Questions</h3>

            <div>
              <Button
                color="secondary"
                className="mr-2"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>

              <Button className="btn-deep-blue" onClick={() => navigate(-1)}>
                Add Selected
              </Button>
            </div>
          </CardHeader>

          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
              <div className="d-flex flex-wrap align-items-center filter-group">
                {/* Search */}
                <Input
                  type="text"
                  placeholder="Search by question"
                  className="mr-2 mb-2 filter-input-large"
                  value={searchState.query}
                  onChange={(e) =>
                    setSearchState((prev) => ({
                      ...prev,
                      query: e.target.value,
                    }))
                  }
                />

                <Select
                  className="mr-2 mb-2 filter-select"
                  options={ANSWER_TYPES}
                  placeholder="Select option type"
                  styles={fixedWidthCustomStyle()}
                  value={searchState.type}
                  onChange={(e) =>
                    setSearchState((prev) => ({
                      ...prev,
                      type: e.target.value,
                    }))
                  }
                />

                {/* Search Button */}
                <Button className="mb-2 filter-btn btn-deep-blue">
                  <i className="fa fa-search mr-1" />
                  Search
                </Button>

                {/* Clear Button */}
                {(searchState.query ||
                  searchState.course ||
                  searchState.batch) && (
                  <Button
                    className="mb-2 filter-btn btn-simple"
                    onClick={() =>
                      setSearchState({
                        query: "",
                        course: null,
                        batch: null,
                        filterParams: [],
                      })
                    }
                  >
                    <i className="fa fa-times mr-1" /> Clear
                  </Button>
                )}
              </div>
            </div>
            <CommonTable
              columns={columns}
              data={questionData}
              defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
              activePage={pageNum}
              setPageNum={setPageNum}
              totalPages={Math.ceil(
                questionData.length / DEFAULT_RECORDS_PER_PAGE,
              )}
              showPaginationBottom
            />
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Questions;
